import * as React from 'react';
import { FaChevronLeft } from 'react-icons/fa';
import { useState } from 'react';
import { IStickyMenu, IStickyMenuItem } from '../../interfaces/umbracoNodes/contentSlices';
import theme from '../../constants/theme';
import {
	DesktopMenu,
	MenuItem,
	MobileMenu,
	MobileMenuDropdown,
	MobileMenuWrapper,
	Root,
	StickyContentContainer,
	StyledLink,
} from './stickyMenu.style';

type Props = {
	content: IStickyMenu;
};

const MenuItemComponent: React.FC<{
	link: IStickyMenuItem;
	isMobileItem: boolean;
	isFirstMobileMenuItem: boolean;
	isMobileMenuOpen?: boolean;
	setIsMobileMenuOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ link, isMobileItem, isFirstMobileMenuItem, isMobileMenuOpen, setIsMobileMenuOpen }) => {
	const handleMenuItemClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
		const isAnchorLink = link.Values.Link.Url.startsWith('#');

		if (isAnchorLink) {
			event.preventDefault();
			const target = document.getElementById(link.Values.Link.Url.substring(1));
			if (target) {
				target.scrollIntoView({ behavior: 'smooth' });
			}
		} else {
			window.location.href = link.Values.Link.Url;
		}
		if (isMobileItem) setIsMobileMenuOpen(false);
	};

	const handleCaretClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		setIsMobileMenuOpen(prevState => !prevState);
	};

	return (
		<MenuItem
			onClick={handleMenuItemClick}
			isMobileItem={isMobileItem}
			isFirstMobileMenuItem={isFirstMobileMenuItem}
			isIconRotated={isMobileMenuOpen}>
			<StyledLink href={link.Values.Link.Url} target={link.Values.Link.Target}>
				{link.Values.Link.Name}
			</StyledLink>
			{isFirstMobileMenuItem && <FaChevronLeft onClick={handleCaretClick} color={theme.colors.primary} />}
		</MenuItem>
	);
};

export const StickyMenu = ({ content }: Props) => {
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

	return (
		<Root>
			<StickyContentContainer>
				<DesktopMenu>
					{content.Values.Links.map((link, index) => (
						<MenuItemComponent key={index} link={link} isMobileItem={false} isFirstMobileMenuItem={false} />
					))}
				</DesktopMenu>
				<MobileMenu>
					<MobileMenuWrapper>
						<MenuItemComponent
							link={content.Values.Links[0]}
							isMobileItem
							isFirstMobileMenuItem
							isMobileMenuOpen={isMobileMenuOpen}
							setIsMobileMenuOpen={setIsMobileMenuOpen}
						/>
						<MobileMenuDropdown isOpen={isMobileMenuOpen}>
							{content.Values.Links.slice(1).map((link, index) => (
								<MenuItemComponent
									key={index}
									link={link}
									isMobileItem
									isFirstMobileMenuItem={false}
									setIsMobileMenuOpen={setIsMobileMenuOpen}
								/>
							))}
						</MobileMenuDropdown>
					</MobileMenuWrapper>
				</MobileMenu>
			</StickyContentContainer>
		</Root>
	);
};
